import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, ClassNameMap, IconButton } from "@mui/material";
import CancelIcon from "../../../icons/cancelIcon.svg";

interface confirmProps {
  classes: ClassNameMap;
  openConfirmRestoreDefaults: boolean;
  setOpenConfirmRestoreDefaults: React.Dispatch<React.SetStateAction<boolean>>;
  confirmRestoreDefaults: () => void;
}

export default function ConfirmRestoreDefaultsDialog(props: confirmProps) {
  return (
    <Dialog
      open={props.openConfirmRestoreDefaults}
      onClose={() => {
        props.setOpenConfirmRestoreDefaults(false);
      }}
      classes={{ paper: props.classes.dialogPaper }}
      className={props.classes.confirmRestoreDefaultsDialog}
      id="confirmRestoreDefaultsDialog"
      PaperProps={{
        style: { borderRadius: 24 },
      }}
    >
      <DialogTitle sx={{ alignSelf: "center", fontSize: 16, pt: "27px", justifyContent: "flex-end", width: "100%", display: "flex", "& p": { mt: 0, mb: 0 } }}>
        <p>Confirm Restore Defaults</p>
        <IconButton
          sx={{ marginLeft: "75px", p: 0 }}
          onClick={() => {
            props.setOpenConfirmRestoreDefaults(false);
          }}
        >
          <img src={CancelIcon} alt="cancel icon" width="26px" height="26px" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ "& .MuiTypography-body1": { fontWeight: 400 } }}>
        <DialogContentText>You are about to restore default settings as they were initially configured during onboarding.</DialogContentText>
        <DialogContentText>Are you sure you want to proceed?</DialogContentText>
      </DialogContent>
      <DialogActions className={props.classes.dialogActionButtons}>
        <Button
          onClick={() => {
            props.setOpenConfirmRestoreDefaults(false);
          }}
          variant="contained"
        >
          No
        </Button>
        <Button
          onClick={() => {
            props.confirmRestoreDefaults();
            props.setOpenConfirmRestoreDefaults(false);
          }}
          variant="contained"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
